(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function mediaTriggers(module) {
    return [...module.querySelectorAll('[data-worn-loved-media]')];
  }

  function showMedia(module, index) {
    const dialog = module.querySelector('[data-worn-loved-dialog]');
    const player = dialog && dialog.querySelector('.yeese-worn-loved__player');
    const image = dialog && dialog.querySelector('.yeese-worn-loved__image');
    const triggers = mediaTriggers(module);
    if (!dialog || !player || !image || triggers.length === 0) return;

    const normalizedIndex = (index + triggers.length) % triggers.length;
    const trigger = triggers[normalizedIndex];
    const url = trigger.dataset.mediaUrl;
    const type = trigger.dataset.mediaType;
    if (!url) return;

    module.dataset.wornLovedIndex = String(normalizedIndex);
    player.pause();
    player.hidden = type !== 'video';
    image.hidden = type !== 'image';

    if (type === 'video') {
      image.removeAttribute('src');
      if (player.src !== url) player.src = url;
    } else {
      player.removeAttribute('src');
      player.load();
      image.src = url;
      image.alt = trigger.getAttribute('aria-label') || '';
    }

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');

    if (type === 'video') {
      const playPromise = player.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }
  }

  function closeMedia(module) {
    const dialog = module.querySelector('[data-worn-loved-dialog]');
    const player = dialog && dialog.querySelector('.yeese-worn-loved__player');
    const image = dialog && dialog.querySelector('.yeese-worn-loved__image');
    if (player) {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }
    if (image) image.removeAttribute('src');
    if (dialog && dialog.open) dialog.close();
  }

  function stepMedia(module, direction) {
    const currentIndex = Number.parseInt(module.dataset.wornLovedIndex || '0', 10);
    showMedia(module, currentIndex + direction);
  }

  function positionModule(module) {
    const productForm = module.closest('product-form') || document.querySelector('product-form.js-product');
    if (!productForm) return;

    if (mobileQuery.matches) {
      const thumbnails = productForm.querySelector('.media-gallery .thumbnails');
      if (thumbnails && thumbnails.nextElementSibling !== module) thumbnails.insertAdjacentElement('afterend', module);
    } else {
      const share = productForm.querySelector('.social-share');
      const shareRow = share && (share.closest('.input-row') || share.parentElement);
      if (shareRow && shareRow.previousElementSibling !== module) shareRow.insertAdjacentElement('beforebegin', module);
    }
  }

  function addMainPlayButton(module) {
    const firstVideoUrl = module.dataset.firstVideoUrl;
    const productForm = module.closest('product-form') || document.querySelector('product-form.js-product');
    const gallery = productForm && productForm.querySelector('.media-gallery');
    if (!firstVideoUrl || !gallery) return;

    const visibleMainImages = [...gallery.querySelectorAll('.main-image')]
      .filter((image) => {
        const rect = image.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && image.offsetParent !== null;
      })
      .sort((imageA, imageB) => {
        const rectA = imageA.getBoundingClientRect();
        const rectB = imageB.getBoundingClientRect();
        const rowDifference = rectA.top - rectB.top;

        // Desktop media is a two-column collage. Select visually by row first,
        // then by column, because its DOM order is not the visual grid order.
        return Math.abs(rowDifference) > 8 ? rowDifference : rectA.left - rectB.left;
      });
    const mainImage = visibleMainImages[0];
    if (!mainImage) return;

    const existingButton = gallery.querySelector('[data-worn-loved-main-play]');
    if (existingButton) {
      if (existingButton.parentElement !== mainImage) mainImage.appendChild(existingButton);
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'yeese-worn-loved__main-play';
    button.dataset.wornLovedMainPlay = '';
    button.setAttribute('aria-label', module.querySelector('.yeese-mobile-link-module__heading')?.textContent.trim() || 'Play video');
    // The play triangle is drawn by CSS. Keeping a text glyph here creates a
    // second (often emoji-styled) arrow on mobile browsers.
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const triggers = mediaTriggers(module);
      const firstVideo = triggers.find((trigger) => trigger.dataset.mediaUrl === firstVideoUrl);
      showMedia(module, Math.max(triggers.indexOf(firstVideo), 0));
    });
    mainImage.appendChild(button);
  }

  function initModule(module) {
    if (module.dataset.wornLovedReady === 'true') {
      positionModule(module);
      addMainPlayButton(module);
      return;
    }

    module.dataset.wornLovedReady = 'true';
    mediaTriggers(module).forEach((trigger, index) => {
      trigger.addEventListener('click', () => showMedia(module, index));
    });

    const dialog = module.querySelector('[data-worn-loved-dialog]');
    module.querySelector('[data-worn-loved-close]')?.addEventListener('click', () => closeMedia(module));
    module.querySelector('[data-worn-loved-prev]')?.addEventListener('click', () => stepMedia(module, -1));
    module.querySelector('[data-worn-loved-next]')?.addEventListener('click', () => stepMedia(module, 1));
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeMedia(module);
    });
    dialog?.addEventListener('close', () => closeMedia(module));
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') stepMedia(module, -1);
      if (event.key === 'ArrowRight') stepMedia(module, 1);
    });

    positionModule(module);
    addMainPlayButton(module);
  }

  function init(root = document) {
    root.querySelectorAll('[data-yeese-worn-loved]').forEach(initModule);
  }

  init();
  mobileQuery.addEventListener('change', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
